import secureLocalStorage from 'react-secure-storage';
import {
    FETCH_START,
    FETCH_END,
    CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS,
    CONTRACT_CONFIGURATION_BY_ID,
} from './ActionTypes';
import axios from '../../../../axios.conf';
import { toast as globalToast } from '../../../../components/ToastManager';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';
import { history } from '../../../../components/Helpers';
export const fetchStart = () => ({ type: FETCH_START });
export const fetchEnd = () => ({ type: FETCH_END });
export const getContractConfigurationData = (params) => {
    return (dispatch) => {
        dispatch(fetchStart());
        getContractConfigurationDataAPI(params).then((response) => {
            dispatch(fetchEnd());
            dispatch(getContractConfigurationDataSuccess(response.data.response));
        }).catch((error) => {
            dispatch(fetchEnd());
            globalToast.showError(
                Array.isArray(error?.response?.data?.message)
                    ? error.response.data.message[0]?.message
                    : error?.response?.data?.message
            );
        });
    };
};

const getContractConfigurationDataAPI = (params) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    let url = '/contract/config-profile?groupBy=profile';
    if (params?.application_type) {
        url += '&application_type=' + params.application_type;
    }
    return axios.get(url, { headers });
};

export const getContractConfigurationDataSuccess = (data) => {
    return {
        type: CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS,
        data,
    };
};

export const fetchContractConfigurationData = (data, id, type, params, rowParams) => {
    return async (dispatch) => {
        dispatch(fetchStart());
        try {
            const response = await fetchContractConfigurationTableDataAPI(data, id, type, rowParams);
            sessionStorage.setItem("contractConfigError", "false");
            dispatch(fetchEnd());

            const logNumber = response?.data?.log_number;
            if (logNumber) {
                const { hasError } = await handleExecutionLog(dispatch, logNumber);
                if (!hasError && type !== 'delete' && type !== 'clone') {
                    history.push({
                        pathname: '/contract-configuration',
                        state: { application: params?.application_type }
                    });
                }
            } else if (type === 'delete') {
                globalToast.showSuccess(
                    response?.data?.message?.message || response?.data?.message || 'Deleted successfully'
                );
            } else {
                globalToast.showSuccess(
                    Array.isArray(response?.data?.message)
                        ? response.data.message[0]?.message
                        : response?.data?.message
                );
                if (type !== 'clone') {
                    history.push({
                        pathname: '/contract-configuration',
                        state: { application: params?.application_type }
                    });
                }
            }
        } catch (error) {
            sessionStorage.setItem("contractConfigError", "true");
            dispatch(fetchEnd());
            if (!error?.response?.data?.log_number) {
                globalToast.showError(
                    Array.isArray(error?.response?.data?.message)
                        ? error.response.data.message[0]?.message
                        : error?.response?.data?.message
                );
            }
        }
    };
};

const fetchContractConfigurationTableDataAPI = (data, id, type, rowParams) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    let result;
    if (type === 'edit') {
        result = axios.put('/contract/config-profile?profile=' + id, data, { headers: headers, });
    }
    else if (type === 'delete') {
        const query = new URLSearchParams({ profile: id });
        if (rowParams?.functionality) query.append('functionality', rowParams.functionality);
        if (rowParams?.application_type) query.append('application_type', rowParams.application_type);
        result = axios.delete(`/contract/config-profile?${query.toString()}`, { headers });
    } else {
        result = axios.post('/contract/config-profile', data, { headers: headers, });
    }
    return result;
};

export const getContractConfigurationDataById = (profileName, params) => {
    return (dispatch) => {
        dispatch(fetchStart());
        return getContractConfigurationDataByIdAPI(profileName, params)
            .then((response) => {
                dispatch(fetchEnd());
                dispatch(getContractConfigurationDataByIdSuccess(response.data.response));
                return response;
            })
            .catch((error) => {
                dispatch(fetchEnd());
                throw error;
            });
    };
};

const getContractConfigurationDataByIdAPI = (id, params) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    const query = new URLSearchParams({ profile: id });
    if (params?.functionality) query.append('functionality', params.functionality);
    if (params?.application_type) query.append('application_type', params.application_type);
    return axios.get(`/contract/config-profile?${query.toString()}`, { headers });
};

export const getContractConfigurationDataByIdSuccess = (data, loader) => {
    return {
        type: CONTRACT_CONFIGURATION_BY_ID,
        data,
    };
};
